import { RootStore } from 'Portals/Customer/stores'

import { TreatmentCategoryTable } from './TreatmentCategoryTable'

export class TreatmentCategoryStore {
	table: TreatmentCategoryTable

	constructor(public rootStore: RootStore) {
		this.table = new TreatmentCategoryTable(rootStore)
	}
}
